(() => {
  const root = document.documentElement;
  if (root.dataset.gxSafariAtcReady) return;
  root.dataset.gxSafariAtcReady = 'true';

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const stickyButton = target.closest('[data-gx-sticky-add]');
    if (!stickyButton || stickyButton.disabled) return;

    const form = stickyButton.closest('[data-gx-product]')?.querySelector('[data-gx-product-form]');
    if (!form || typeof form.requestSubmit === 'function') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
    if (form.dispatchEvent(submitEvent) && (!form.reportValidity || form.reportValidity())) {
      stickyButton.disabled = true;
      form.submit();
    }
  }, true);
})();
